import React, { useEffect, useState } from "react";
import { useRoutes, Navigate, useNavigate } from "react-router-dom";
import "./App.css";
import InviteCandidateView from "./pages/candidate/InviteCandidateView";
import InvalidAccessCodeView from "./pages/candidate/InvalidAccessCodeView";
import Default from "./pages/default/Default";
import ColoredLinearProgress from "./components/controls/coloredLoadingProgress";
import { useDispatch, useSelector } from "react-redux";
import authAction from "./redux/actions/auth";
import ErrorSnackbar from "./components/controls/Errormessage";
import PrivacyPolicy from "./pages/legalpages/privacy";
import TermsConditions from "./pages/legalpages/Terms&condidtions";
import CandidateProfile from "./pages/CandidateProfile/CandidateProfile";
import CandidateJobSpecificProfile from "./pages/CandidateJobSpecificProfile/CandidateJobSpecificProfile";

const AppRouter = (props) => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth);
  const roleState = useSelector((state) => state.role);
  const quizState = useSelector((state) => state.quiz);
  let apiError = useSelector((state) => state?.auth?.apiError);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  let navigate = useNavigate();

  // const location = useLocation()
  useEffect(() => {
    if (apiError) {
      if (apiError?.response?.status === 401) {
        navigate("/");
      }
      if (apiError?.response?.data?.message === "Authentication failed. Invalid user or password.") {
        setToastMessage("Authentication failed. Invalid User ID or Password.");
      } else if (apiError?.response?.data?.message === "Authentication failed. User is not active.") {
        setToastMessage(apiError?.response?.data?.message);
      } else if (apiError?.response?.data?.errors?.[0]?.msg) {
        if (apiError?.response?.data?.errors?.[0]?.msg === "roleSubType must not be empty.") {
          setToastMessage("Role Type must not be empty.");
        } else if (apiError?.response?.data?.errors?.[0]?.msg === "type must not be empty.") {
          setToastMessage("Role Type must not be empty.");
        } else if (apiError?.response?.data?.errors?.[0]?.msg === "name must not be empty.") {
          setToastMessage("Role Title must not be empty.");
        } else {
          setToastMessage(apiError?.response?.data?.errors?.[0]?.msg);
        }
      } else if (apiError?.message) {
        setToastMessage(apiError?.message);
      } else {
        setToastMessage("Internal server error!");
      }
      setOpenToast(true);
    }
    // eslint-disable-next-line
  }, [apiError]);

  function setOpenFunc() {
    setOpenToast(false);
    dispatch(authAction.apiError(""));
  }
  let routes = useRoutes([
    { path: "/", element: <Default /> },
    { path: "/:id/:accessCode", element: <InviteCandidateView /> },
    {
      path: "/inValidAccess",
      element: (
        <InvalidAccessCodeView
          errmsg={
            roleState?.inviteDetailsFailure ||
            roleState?.CandidateJobSpecificProfileFailure ||
            roleState?.CandidateProfileFailure
          }
        />
      ),
    },
    { path: "*", element: <Navigate to="/" /> },
    { path: "/terms&conditions", element: <TermsConditions /> },
    { path: "/privacypolicy", element: <PrivacyPolicy /> },
    { path: "/candidate/:candidateId/profile/:profileToken", element: <CandidateProfile /> },
    { path: "/candidate/:candidateId/role/:roleId/:profileToken", element: <CandidateJobSpecificProfile /> },
  ]);
  return (
    <>
      {routes}
      <div>
        {authState.isauthLoading ? (
          <div className={props.loader}>
            <ColoredLinearProgress />
          </div>
        ) : null}
        {quizState.isquizLoading ? (
          <div className={props.loader}>
            <ColoredLinearProgress />
          </div>
        ) : null}
        {roleState.isLoading || roleState.isroleLoading ? (
          <div className={props.loader}>
            <ColoredLinearProgress />
          </div>
        ) : null}
      </div>
      <ErrorSnackbar
        open={openToast}
        setOpen={() => setOpenFunc()}
        vertical={"bottom"}
        horizontal={"left"}
        severity="error"
        message={toastMessage}
      />
    </>
  );
};

export default AppRouter;
